import styled from "styled-components";
import colors from "../../../config/colors";

export const ChipSelectContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Option = styled.div`
    padding:2px 15px;
    font-weight:${(props) => (props.active ? "bold" : "normal")};
    border:solid 1px ${colors.darkPrimary};
    background-color: ${(props) =>
      props.disabled? colors.darkBackground : 
      props.active ? colors.darkPrimary : colors.background};
               color: ${(props) =>
                 props.active ? colors.background : colors.darkPrimary};
    cursor:pointer;
    border-right:none;
    transition:all 0.2s;
    :first-of-type{
        border-radius: 10px 0px 0px 10px;
    }
    :last-of-type{
        border-right:solid 1px ${colors.darkPrimary};
        border-radius: 0px 10px 10px 0px;
    }s
`;

export const Label = styled.div`
  margin-right: 10px;
`;
export const OptionsList = styled.div`
  display: flex;
  align-items: center;
`;
